import { ApiPath } from '@/common/app/api-path';
import {
  type AuthEmailRequestType,
  type VerifyEmailRequestType,
} from '@/common/types/auth';
import {
  type TonAuthGeneratePayloadResponse,
  type TonAuthLoginRequest,
} from '@/common/types/ton-auth';
import { type User } from '@/common/types/userType';

import { api } from '../base';

const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    loginWithEmail: builder.mutation<void, AuthEmailRequestType>({
      query: (body) => ({
        url: ApiPath.AUTH_EMAIL,
        method: 'POST',
        body,
      }),
    }),
    verifyEmail: builder.mutation<void, VerifyEmailRequestType>({
      query: (body) => ({
        url: ApiPath.EMAIL_VERIFY,
        method: 'POST',
        body,
      }),
    }),
    tonGeneratePayload: builder.query<TonAuthGeneratePayloadResponse, void>({
      query: () => ApiPath.TON_AUTH_GENERATE_PAYLOAD,
    }),
    tonLogin: builder.mutation<User, TonAuthLoginRequest>({
      query: (body) => ({
        url: ApiPath.TON_AUTH_LOGIN,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useLoginWithEmailMutation,
  useVerifyEmailMutation,
  useLazyTonGeneratePayloadQuery,
  useTonLoginMutation,
} = authApi;
export { authApi };
